import { APIModel } from '@shared/interfaces';

export class QuestionFieldCondition implements APIModel {
    id = -1;
    logicalOperator!: string;
    dependsOn!: number;
    comparisonOperator!: string;
    value?: any;

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.logicalOperator = data.logical_operator;
        this.dependsOn = data.depends_on;
        this.comparisonOperator = data.comparison_operator;
        this.value = data.value ?? undefined;
        return this;
    }

    checkCondition(value: any): boolean {
        let result = true;
        const listValue = Array.isArray(value) ? value : [value];
        switch (this.comparisonOperator) {
            case 'equal':
                result = listValue.some((val) => val === this.value);
                break;
            case 'not_equal':
                result = listValue.some((val) => val !== this.value);
                break;
            case 'greater':
                result = listValue.some((val) => val > this.value);
                break;
            case 'greater_or_equal':
                result = listValue.some((val) => val >= this.value);
                break;
            case 'smaller':
                result = listValue.some((val) => val < this.value);
                break;
            case 'smaller_or_equal':
                result = listValue.some((val) => val <= this.value);
                break;
            case 'in':
                result = listValue.some((val) => this.value.includes(val));
                break;
            case 'not_in':
                result = listValue.some((val) => !this.value.includes(val));
                break;
        }
        return result;
    }
}
